import { AuthState, useIdentify } from '@hungryroot/customer';
import { useIsEmbeddedWebView } from '@hungryroot/environment';
import { ROUTE_CYO } from '@hungryroot/page-cyo';
import { ROUTE_SIGN_UP } from '@hungryroot/page-signup';
import { ROUTE_PLAN_PRECHECKOUT } from '@hungryroot/plan';
import { LAST_ROUTE, ROUTE_SWEETS_FREQUENCY } from '@hungryroot/quiz';
import { BUILDING_PATH } from '../components/Building/Building';

export function useFunnelRedirects() {
  const customer = useIdentify();
  const isEmbeddedWebView = useIsEmbeddedWebView();

  if (customer.authState === AuthState.isLoading) {
    return null;
  }

  const customerIsAuthenticated =
    customer.authState === AuthState.isAuthenticated;

  // After user is signed up, send to Plan page if it's a mobile webview, otherwise CYO
  const afterBuildingAfterQuizRedirect = isEmbeddedWebView
    ? ROUTE_PLAN_PRECHECKOUT
    : ROUTE_CYO;

  // Only show the Building screen once, pre-signup
  const afterQuiz =
    customerIsAuthenticated === true
      ? afterBuildingAfterQuizRedirect
      : BUILDING_PATH;

  // After Building screen finishes, send the user to signup if they are logged out
  // Technically, with the above logic, a logged-in user can't get to the Building screen organically,
  // but this satisfies an e2e test that checks there isn't an infinite redirect and this helps solve the redirect issue
  // In the unlikely event that a logged-in user gets to the Building screen somehow
  const afterBuilding =
    customerIsAuthenticated === true
      ? afterBuildingAfterQuizRedirect
      : ROUTE_SIGN_UP;

  // If user clicks Back on Plan screen, go back to Sweets if on mobile webview, otherwise CYO
  const beforePlan = isEmbeddedWebView ? ROUTE_SWEETS_FREQUENCY : ROUTE_CYO;

  return {
    afterQuiz,
    afterBuilding,
    afterSignup: afterBuildingAfterQuizRedirect,
    afterCyo: ROUTE_PLAN_PRECHECKOUT,
    beforeCyo: LAST_ROUTE,
    beforePlan,
  } as const;
}
